import React from "react";
import Select from "react-select";
import * as api from "../../services/api/admin";
import { Loader } from "../Loader";

class SelectMultipleDepartment extends React.Component {
  constructor(props) {
    super(props);
    this.state = { items: [] };
  }

  componentDidMount() {
    this.getItems();
  }

  getItems() {
    api.getDepartments().then(res => {
      this.setState({ items: res });
    });
  }

  options() {
    return this.state.items
      .sort((a, b) => {
        return a.name.localeCompare(b.name);
      })
      .map((item, index) => ({ value: item.id, label: item.name }));
  }

  render() {
    return (
      <>
        {this.state.items.length !== 0 ? (
          <Select
            options={this.options()}
            placeholder="Departamentos..."
            isMulti
            styles={{
              container: () => ({
                width: "100%",
                padding: "0"
              })
            }}
            onChange={this.props.onChange}
          />
        ) : (
          <Loader />
        )}
      </>
    );
  }
}

export default SelectMultipleDepartment;
